import type { WeeklySchedule } from '@/types'
import { isCurrentlyOpen } from '@/types'

/**
 * Determines if a clinic is currently in emergency-only mode
 * (regular hours closed, emergency hours active).
 * Client-only — returns false during SSR.
 */
export function useEmergencyStatus(
  workingHours: Ref<WeeklySchedule | null> | WeeklySchedule | null,
  emergencyHours: Ref<WeeklySchedule | null> | WeeklySchedule | null,
  is24Hours: Ref<boolean> | boolean,
) {
  const isMounted = ref(false)

  onMounted(() => {
    isMounted.value = true
  })

  const isEmergencyActive = computed(() => {
    if (!isMounted.value) return false

    const is24h = toValue(is24Hours)
    if (is24h) return false

    const working = toValue(workingHours)
    const emergency = toValue(emergencyHours)

    const isOpen = working ? isCurrentlyOpen(working) : false
    if (isOpen) return false

    return emergency ? isCurrentlyOpen(emergency) === true : false
  })

  return { isEmergencyActive }
}
